import { QueryClient } from '@tanstack/react-query';
import Api from '../Api';
import { Preview } from '../../types/design';
import { McpProduct } from '../../types/product/product';
import { ISelection } from '../../types/selector/Selector';
import { getStore } from '../../helpers/env';

interface GetPreviewsRequest {
  documentReferenceUrl: string;
  mcpSku: string;
  mcpAttributes: string;
  numberOfCanvasses: number;
  width: number;
}

interface ConvertProductRequest {
  productKey: string;
  selection: ISelection;
  productVersion: number;
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      gcTime: Infinity,
      placeholderData: (previousData: unknown) => previousData,
    },
  },
});

class ArtworkService extends Api {
  queryClient = queryClient;

  async getPreviews(params: GetPreviewsRequest): Promise<Preview[]> {
    return this.queryClient.fetchQuery<Preview[]>({
      queryKey: [
        'getPreviews',
        JSON.parse(params.mcpAttributes),
        params.mcpSku,
      ],
      queryFn: async () => {
        const { data } = await this.httpClient.get<Preview[]>(
          '/previews',
          {
            params: { ...params, documentReference: params.documentReferenceUrl },
          },
        );

        return data;
      },
    });
  }

  async convertProduct(params: ConvertProductRequest): Promise<McpProduct> {
    const storeKey = getStore();
    return this.queryClient.fetchQuery<McpProduct>({
      queryKey: [
        'convert-product',
        params.productKey,
        JSON.stringify(params.selection),
        params.productVersion,
        storeKey,
      ],
      queryFn: async () => {
        const { data } = await this.httpClient.get<McpProduct>(
          `/convert-product/${params.productKey}/${params.productVersion}`,
          {
            params: {
              selection: JSON.stringify(params.selection),
              storeKey,
            },
          },
        );

        return data;
      },
    });
  }
}

export default ArtworkService;
